import { UserOutlined } from "@ant-design/icons";
import { Avatar, Button, Popover } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/store";
import { logout } from "src/store/slices/auth";
import CurrentProgramHeader from "../CurrentProgramHeader";

function PageHeader() {
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.auth.user);

  return (
    <header className="flex items-center justify-between mb-4">
      <CurrentProgramHeader />
      <Popover
        content={
          <div className="flex flex-col gap-4">
            <div className="flex gap-2 items-center">
              <Avatar
                className="w-10 h-10 flex items-center justify-center"
                icon={<UserOutlined />}
              />
              <p className="font-semibold">{user?.Client}</p>
            </div>
            <Button danger onClick={() => dispatch(logout())}>
              Logout
            </Button>
          </div>
        }
      >
        <Avatar
          className="w-10 h-10 flex items-center justify-center"
          icon={<UserOutlined />}
        />
      </Popover>
    </header>
  );
}

export { PageHeader };
